/* unplugin-vue-components disabled */import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-button.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7bb2b20a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "receive-dialog"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "qr-code-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "address"
};
const _hoisted_6 = {
  class: "supported-networks"
};
const _hoisted_7 = {
  class: "supported-networks-icons"
};
import { supportedChainListInfo } from '@/service/chains-config';
import { useUserStore } from '@/store/user';
import { copy } from '@/utils/useUniPass';
import { useIndexWalletConnect } from '@/composable/useIndex';
import { useCoinStore } from '@/store/coin';
export default /*#__PURE__*/_defineComponent({
  __name: 'receive-dialog',
  emits: ["close"],

  setup(__props, {
    emit: $emit
  }) {
    const {
      scan,
      scanModal
    } = useIndexWalletConnect();
    const coinStore = useCoinStore();
    const userStore = useUserStore();
    const icons = supportedChainListInfo.map(item => item.label);
    const inited = computed(() => {
      const user = userStore.accountInfo;

      if (!user.address) {
        return false;
      }

      scanModal.initQRCode(user.address);
      coinStore.fetchBalances();
      return true;
    });
    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      const _component_up_button = __unplugin_components_1;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Receive')), 1), _createVNode(_component_up_icon, {
        class: "close",
        name: "close",
        onClick: _cache[0] || (_cache[0] = $event => $emit('close'))
      })]), _createElementVNode("div", _hoisted_3, [_unref(inited) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(scan).addressQRCode,
        class: "qr-code"
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userStore).accountInfo.address), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('SupportedNetworks')), 1), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icons), (icon, i) => {
        return _openBlock(), _createBlock(_component_up_icon, {
          width: "24",
          height: "24",
          name: icon,
          key: i
        }, null, 8, ["name"]);
      }), 128))]), _createVNode(_component_up_button, {
        class: "copy",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => _unref(copy)(_unref(userStore).accountInfo.address))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('CopyAddress')), 1)]),
        _: 1
      })]);
    };
  }

});